import "./App.css";
import AboutSection from "../components/UI/about/aboutSection";
import TripsSection from "../components/UI/trips/tripsSection";
import { useLocation } from "react-router-dom";
import { useLayoutEffect, useRef } from "react";
import SafarisSection from "../components/UI/trips/safarisSection";
import ContactSection from "../components/UI/contact/contactSection";
import Footer from "../components/UI/footer/footer";

function App() {
  const location = useLocation();
  const tripsSectionRef = useRef(null);

  useLayoutEffect(() => {
    const timeoutId = setTimeout(() => {
      if (location.hash) {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, 250);

    return () => clearTimeout(timeoutId);
  }, [location.hash]);

  return (
    <div className="App">
      <div className="App-container">
        <div id="about-section" ref={tripsSectionRef}>
          <AboutSection />
        </div>
        <div id="trips-section">
          <TripsSection />
        </div>
        <div id="safaris-section">
          <SafarisSection />
        </div>
        <div id="contact-section">
          <ContactSection />
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
